import { Record } from 'immutable';

export const Err = Record({
  errorCode: 'general',
  errorMessage: 'An error has occurred.'
});



// WEBPACK FOOTER //
// src/err.js